import PageError from "./pageError";
import { DutyStatusLogService } from "../model/DutyStatusLogs";
import DutyStatusLog from "../model/DutyStatusLog";

const DEFAULT_ATTRIBUTE_NAME = "unknownAttribute";

export const enum ValidatorParameters {
    annotations = "annotations",
    dateTime = "dateTime",
    device = "device",
    previousLogStatus = "previousLogStatus"
}

export class ValidationErrorLogger {
    private readonly errorsList: PageError[] = [];
    private currentAttributeName: string = DEFAULT_ATTRIBUTE_NAME;

    set attributeName (name: string) {
        this.currentAttributeName = name || DEFAULT_ATTRIBUTE_NAME;
    }

    addError (errorText: string) {
        errorText && this.errorsList.push(new PageError(this.currentAttributeName, errorText));
    }

    getErrors () {
        return this.errorsList;
    }
}

/* To implement validation you should create methods in your model with names according to pattern
    <validate<AttributeName>> in your model
*/

export default class Validator {
    private validationErrors: PageError[] = [];

    constructor(private readonly dutyStatusLogService: DutyStatusLogService) {
    }

    get errors (): PageError[] {
        return this.validationErrors;
    }

    /**
     * Checks if Annotation, DateTime and Device are valid
     *
     * @param model - The DSL log to validate
     * @param collection - The collection of DSL logs to validate against
     * @param validatingAttributes - The enum of attributes to validate
     * @param previousEwdLog - The previous DSL log to validate against (for EWD)
     * @returns Returns a boolean indicating whether the operation is valid or not;
     * If validationErrors length is greater than 0 it means there's an error message hence the operation is not valid.
     */
    validate (model: DutyStatusLog, collection: DutyStatusLog[], validatingAttributes?: ValidatorParameters[], previousEwdLog?: DutyStatusLog | null): boolean {
        let errorLogger: ValidationErrorLogger = new ValidationErrorLogger();
        let existingLog = this.dutyStatusLogService.getLogById(collection, model.id);

        if (!validatingAttributes || validatingAttributes.indexOf(ValidatorParameters.annotations) > -1) {
            errorLogger.attributeName = ValidatorParameters.annotations;
            this.dutyStatusLogService.validateAnnotations(model.annotations, errorLogger, existingLog ? existingLog.annotations : null);
        }
        if (!validatingAttributes || validatingAttributes.indexOf(ValidatorParameters.dateTime) > -1) {
            errorLogger.attributeName = ValidatorParameters.dateTime;
            this.dutyStatusLogService.validateDateTime(model.dateTime, errorLogger, existingLog?.dateTime, previousEwdLog);
        }
        if (!validatingAttributes || validatingAttributes.indexOf(ValidatorParameters.previousLogStatus) > -1) {
            errorLogger.attributeName = ValidatorParameters.previousLogStatus;
            this.dutyStatusLogService.validatePreviousLogStatus(model, errorLogger, collection, existingLog);
        }
        if (!validatingAttributes || validatingAttributes.indexOf(ValidatorParameters.device) > -1) {
            errorLogger.attributeName = ValidatorParameters.device;
            this.dutyStatusLogService.validateDevice(model, model.device, errorLogger);
        }
        this.validationErrors = errorLogger.getErrors();
        return this.validationErrors.length === 0;
    }
}